export default __webpack_public_path__ + "static/media/223.66e74f10.jpg";